(() => {
  if (window.fusedCreativeReady) return;
  window.fusedCreativeReady = true;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pointer = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  let observer;
  function init(root = document) {
    if (!motion.matches && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
      observer ||= new IntersectionObserver(entries => {
        entries.forEach(({ target, isIntersecting }) => {
          if (!isIntersecting) return;
          target.classList.add('fs-arrived');
          observer.unobserve(target);
        });
      }, { threshold: 0.08 });
      root.querySelectorAll('.fs-reveal:not(.fs-arrived)').forEach(el => observer.observe(el));
    }
    root.querySelectorAll('.fs-tilt').forEach(el => {
      if (el.dataset.fsBound) return;
      el.dataset.fsBound = 'true';
      let frame;
      const reset = () => {
        cancelAnimationFrame(frame);
        el.style.removeProperty('--fs-rx');
        el.style.removeProperty('--fs-ry');
      };
      el.addEventListener('pointermove', event => {
        if (motion.matches || !pointer.matches || event.pointerType === 'touch') return;
        const { left, top, width, height } = el.getBoundingClientRect();
        const rx = (0.5 - (event.clientY - top) / height) * 4;
        const ry = ((event.clientX - left) / width - 0.5) * 5;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          el.style.setProperty('--fs-rx', `${rx}deg`);
          el.style.setProperty('--fs-ry', `${ry}deg`);
        });
      }, { passive: true });
      el.addEventListener('pointerleave', reset);
      el.addEventListener('pointercancel', reset);
      motion.addEventListener('change', reset);
      pointer.addEventListener('change', reset);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
